angular.module('gym').factory('NonAttendingContactForms', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var gymId;
  gymId = $rootScope.toParams.gymId;
  return Restangular.one('gyms', gymId).all('forms').all('non_attending_contact_forms.json');
}]);
